export function fetch(id) { return { type: 'PLANS/FETCH', id } }
export function fetch_one(id) { return { type: 'PLAN/FETCH', id } }
export function archive(id, IdProperty) { return { type: 'PLAN/ARCHIVE', id, IdProperty } }
export function toggle(id, IsActive) { return { type: 'PLAN/TOGGLE', id, IsActive } }
export function clean() { return { type: 'PLAN/CLEAR' } }